module.exports = __webpack_public_path__ + "static/media/eos-icon.46708124.svg";